import { cn, Flex } from '@bridebook/aura';
import { useIsVenueProfileV2 } from '@bridebook/web/app-basic/components/supplier/hooks/use-is-venue-profile-v2';
import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import BrochureWell from '../brochure-well/brochure-well';
import SocialBar from '../social-bar';
import { BookAViewingButton } from './book-a-viewing/book-a-viewing-button';
import { getHasInstantBrochures } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useIsShowroundsLoggedOutUsers_LIVE28500_Enabled } from '@bridebook/web/app-basic/lib/ab-tests/tests/LIVE-28500_ShowroundsLoggedOutUsers';

export const CTAButtonsWrapper = () => {
  const isVenueProfileV2 = useIsVenueProfileV2();
  const isMobile = useSelector(getIsMobile);
  const hasInstantBrochures = useSelector(getHasInstantBrochures);
  const isShowroundsLoggedOutUsersEnabled = useIsShowroundsLoggedOutUsers_LIVE28500_Enabled();
  return (
    <>
      {isVenueProfileV2 ? (
        isMobile && (
          <Flex className={cn('order-5 mt-5 mb-0 flex-col gap-4', hasInstantBrochures && 'gap-5')}>
            <BrochureWell />
            {isShowroundsLoggedOutUsersEnabled && (
              <div className="flex w-full px-4">
                <BookAViewingButton />
              </div>
            )}
          </Flex>
        )
      ) : (
        <Flex className={cn('mb-4 flex-col items-center gap-2 pt-2 xl:order-5 xl:mb-0')}>
          {isMobile && (
            <Flex className="w-full">
              <SocialBar />
            </Flex>
          )}
          <BrochureWell />
        </Flex>
      )}
    </>
  );
};
